import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

export const loginGuard = () =>
  inject(AuthenticationService).authenticated$.pipe(map((authenticated) => !authenticated));